import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function ExceptionReducer(state = initialState.exception, action) {
	switch (action.type) {
		case types.THROW_EXCEPTION: {
			let body = action.body.exception;

			if (action.body && action.body.exception instanceof Error) {
				body = {};
				let propNames = Object.getOwnPropertyNames(action.body.exception);
				for (let key in propNames) {
					body[propNames[key]] = action.body.exception[propNames[key]];
				}
			}
			else if (typeof action.body === 'string') {
				body = { message: body };
			}
			return Object.assign({}, state, { exception: body, redirectToExceptionPage: action.body.redirectToExceptionPage });
		}
		case types.CLEAR_EXCEPTION: {
			return { exception: null, redirectToExceptionPage: false };
		}
		default:
			return state;
	}
}
